<template>
  <section class="evento-lux">
    <img src="@/assets/petalos.png" class="petalo-flotante petalo-izq-1" alt="" />
    <img src="@/assets/petalos.png" class="petalo-flotante petalo-der-1" alt="" />

    <!-- BLOQUE 1: CEREMONIA -->
    <div ref="seccionBloque1" class="bloque-evento" aria-label="Ceremonia">
      <img class="icono-lazo" src="@/assets/igle.png" alt="Icono Ceremonia" />
      
      <p class="hora-top">12:00 P.M.</p>
      <h3 class="titulo-editorial">CEREMONIA RELIGIOSA</h3>
      <p class="lugar-luxury">Templo Expiatorio del Sagrado Corazón de Jesús</p>
      <p class="direccion-editorial">
       C. Francisco I. Madero 721, Centro<br />
      León, Guanajuato.
      </p>

      <div class="imagen-lugar-wrapper shadow-luxury-img">
        <img src="@/assets/Catedral gótica al atardecer.png" class="imagen-lugar" alt="Ceremonia Venue" />
      </div>

      <a
        ref="btn1"
        class="btn-editorial-rosa"
        href="https://maps.app.goo.gl/4cB5md8Hoh1DTdRc9"
        target="_blank"
        rel="noopener"
      >
        GOOGLE MAPS
        <span class="sheen"></span>
      </a>
    </div>

    <div class="espaciador-bloques"></div>

    <!-- BLOQUE 2: RECEPCIÓN -->
    <div ref="seccionBloque2" class="bloque-evento" aria-label="Recepción">
      <img class="icono-lazo" src="@/assets/cel.avif" alt="Icono Recepción" />
      
      <p class="hora-top">4:30 P.M.</p>
      <h3 class="titulo-editorial">RECEPCIÓN</h3>
      <p class="lugar-luxury">Salon de Fiestas Casa Nueva
</p>
      <p class="direccion-editorial">
      Luis Valadez 111, La Laborcita <br />
        León, Guanajuato.
      </p>

      <div class="imagen-lugar-wrapper shadow-luxury-img">
        <img src="@/assets/Entrada de Ensueño en Casa Nueva.png" class="imagen-lugar" alt="Recepción Venue" />
      </div>

      <a
        ref="btn2"
        class="btn-editorial-rosa"
        href="https://maps.app.goo.gl/dVFFGSLixQaNUTBs7"
        target="_blank"
        rel="noopener"
      >
        GOOGLE MAPS
        <span class="sheen"></span>
      </a>
    </div>

   
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {
    const seccionBloque1 = ref(null)
    const seccionBloque2 = ref(null)
    const btn1 = ref(null)
    const btn2 = ref(null)

    let ctx1
    let ctx2
    let animPetalos

    const crearAnimacionEditorial = (bloqueEl, btnEl, esBloqueUno = true) => {
      if (!bloqueEl || !btnEl) return

      const $ = gsap.utils.selector(bloqueEl)
      
      const lazo = $('.icono-lazo')
      const hora = $('.hora-top')
      const titulo = $('.titulo-editorial')
      const lugar = $('.lugar-luxury')
      const dir = $('.direccion-editorial')
      const imgLugar = $('.imagen-lugar-wrapper')

      // Timeline con tiempos secuenciales definidos para impacto consecutivo
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: bloqueEl,
          start: 'top 82%', // Espera a que el bloque esté bien posicionado en viewport
          toggleActions: 'play none none none',
          once: true
        }
      })

      // 1. Entrada del contenedor principal con desenfoque
      tl.fromTo(bloqueEl, 
        { opacity: 0, y: 50 }, 
        { opacity: 1, y: 0, duration: 1.0, ease: 'power3.out' }
      )

      // 2. Icono (Caída suave con ligera escala)
      .fromTo(lazo, 
        { opacity: 0, scale: 0.5, y: -30, filter: 'blur(6px)' }, 
        { opacity: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 1.1, ease: 'back.out(1.5)' }, 
        '-=0.7'
      )

      // 3. Hora (Aparece flotando desde abajo)
      .fromTo(hora, 
        { opacity: 0, y: 25, filter: 'blur(4px)' }, 
        { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.9, ease: 'power2.out' }, 
        '-=0.7'
      )

      // 4. Título Editorial (Apertura de tracking tipográfico)
      .fromTo(titulo, 
        { opacity: 0, y: 30, letterSpacing: '0.25em', filter: 'blur(8px)' }, 
        { opacity: 1, y: 0, letterSpacing: '0.12em', filter: 'blur(0px)', duration: 1.2, ease: 'power3.out' }, 
        '-=0.6'
      )

      // 5. Nombre del Lugar (Revelado con escala fina)
      .fromTo(lugar, 
        { opacity: 0, y: 20, scale: 0.95, filter: 'blur(5px)' }, 
        { opacity: 1, y: 0, scale: 1, filter: 'blur(0px)', duration: 1.0, ease: 'power2.out' }, 
        '-=0.7'
      )

      // 6. Dirección
      .fromTo(dir, 
        { opacity: 0, y: 20 }, 
        { opacity: 1, y: 0, duration: 0.9, ease: 'power2.out' }, 
        '-=0.7'
      )

      // 7. Imagen circular (Giro 3D y despliegue orgánico)
      .fromTo(imgLugar, 
        { 
          opacity: 0, 
          scale: 0.6, 
          rotationY: esBloqueUno ? -25 : 25, 
          rotationZ: esBloqueUno ? -8 : 8, 
          y: 40,
          filter: 'blur(10px)'
        }, 
        { 
          opacity: 1, 
          scale: 1, 
          rotationY: 0, 
          rotationZ: 0, 
          y: 0, 
          filter: 'blur(0px)',
          duration: 1.4, 
          ease: 'back.out(1.2)' 
        }, 
        '-=0.6'
      )

      // 8. Botón Google Maps (Expansión suave final)
      .fromTo(btnEl, 
        { opacity: 0, y: 25, scale: 0.88, filter: 'blur(4px)' }, 
        { opacity: 1, y: 0, scale: 1, filter: 'blur(0px)', duration: 1.0, ease: 'power3.out' }, 
        '-=0.8'
      )

      // 9. Destello final del botón (Sheen)
      .fromTo(btnEl.querySelector('.sheen'),
        { xPercent: -120, opacity: 0 },
        { xPercent: 140, opacity: 1, duration: 1.3, ease: 'power2.inOut' },
        '-=0.2'
      )
    }

    onMounted(async () => {
      await nextTick()

      if (seccionBloque1.value) {
        ctx1 = gsap.context(() => {
          crearAnimacionEditorial(seccionBloque1.value, btn1.value, true)
        }, seccionBloque1.value)
      }

      if (seccionBloque2.value) {
        ctx2 = gsap.context(() => {
          crearAnimacionEditorial(seccionBloque2.value, btn2.value, false)
        }, seccionBloque2.value)
      }

      // Flotación constante de pétalos
      animPetalos = gsap.to('.petalo-flotante', {
        y: '+=15',
        rotation: '+=8',
        duration: 4.2,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        stagger: 0.4
      })
    })

    onUnmounted(() => {
      if (ctx1) ctx1.revert()
      if (ctx2) ctx2.revert()
      if (animPetalos) animPetalos.kill()
    })

    return { seccionBloque1, seccionBloque2, btn1, btn2 }
  }
}
</script>

<style scoped>
/* ==================== CONFIGURACIÓN ESTILO EDITORIAL COINCIDENTE ==================== */
.evento-lux {
  position: relative;
  width: 100%;
  min-height: 100vh;
  margin-top:-5px;
  padding: 60px 20px 70px;
  background:
    radial-gradient(ellipse at 50% 20%, rgba(255, 255, 255, 0.95), rgba(253, 242, 243, 0.98)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="6"><rect width="6" height="6" fill="white"/><circle cx="3" cy="3" r="0.5" fill="%23f4eae9"/></svg>') repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
}

/* ==================== BLOQUES CONTENEDORES CONTRAÍDOS ==================== */
.bloque-evento {
  width: min(100%, 420px);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  perspective: 1000px; /* Habilita giros 3D limpios */
}

.espaciador-bloques {
  height: 90px;
  width: 100%;
}

.icono-lazo {
  width: auto;
  height: clamp(90px, 20vh, 180px) !important;
  display: block;
  margin: 0 auto 18px;
  object-fit: contain;
  filter: drop-shadow(0 4px 10px rgba(225, 180, 185, 0.25));
  will-change: transform, opacity, filter;
}

/* ==================== IMAGEN CIRCULAR LUXURY ==================== */
.imagen-lugar-wrapper {
  width: min(75vw, 210px);
  height: min(75vw, 210px);
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 28px;
  background: #ffffff;
  border: 3px solid #ffffff;
  will-change: transform, opacity, filter;
  transform-style: preserve-3d;
}

.imagen-lugar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.shadow-luxury-img {
  box-shadow: 
    0 10px 30px rgba(225, 180, 185, 0.3),
    0 2px 8px rgba(0, 0, 0, 0.04);
}

/* ==================== TIPOGRAFÍAS DE ALTA GAMA ==================== */
.hora-top {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(20px, 4.5vw, 24px);
  font-weight: 400;
  color: #333333;
  margin: 0 0 4px 0;
  letter-spacing: 0.05em;
  will-change: transform, opacity, filter;
}

.titulo-editorial {
  font-family: 'Playfair Display', serif;
  font-weight: 400;
  font-size: clamp(38px, 9vw, 46px);
  color: #e6b1c4;
  margin: 0 0 12px 0;
  letter-spacing: 0.12em;
  line-height: 1.1;
  will-change: transform, opacity, filter, letter-spacing;
}

.lugar-luxury {
  font-family: 'padres', serif;
  font-size: clamp(26px, 6vw, 32px);
  color: #1a1a1a;
  font-weight: 500;
  margin: 0 0 10px 0;
  line-height: 1.2;
  will-change: transform, opacity, filter;
}

.direccion-editorial {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  color: #555555;
  font-size: clamp(14px, 3.2vw, 15px);
  line-height: 1.6;
  margin: 0 auto 20px;
  max-width: 85%;
  letter-spacing: 0.02em;
  will-change: transform, opacity;
}

/* ==================== BOTÓN DE DISEÑO FLUSH ==================== */
.btn-editorial-rosa {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: min(100%, 260px);
  padding: 13px 28px;
  border-radius: 12px;
  background: #d6bac5;
  color: #ffffff;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  box-shadow: 0 6px 20px rgba(222, 176, 182, 0.35);
  transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.2s ease;
  border: none;
  overflow: hidden;
  will-change: transform, opacity, filter;
}

.btn-editorial-rosa:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(222, 176, 182, 0.5);
}

.btn-editorial-rosa:active {
  transform: translateY(0);
}

.btn-editorial-rosa .sheen {
  position: absolute;
  top: -30%;
  left: -30%;
  width: 50%;
  height: 160%;
  transform: rotate(25deg);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0) 100%);
  pointer-events: none;
  mix-blend-mode: screen;
}

/* ==================== PÉTALOS ACENTUADOS A LOS COSTADOS ==================== */
.petalo-flotante {
  position: absolute;
  width: min(22vw, 90px);
  height: auto;
  object-fit: contain;
  pointer-events: none;
  opacity: 0.85;
  z-index: 1;
}

.petalo-izq-1 {
  top: 9vh;
  left: -4vw;
  transform: rotate(-15deg);
}

.petalo-der-1 {
  top: 62vh;
  right: -5vw;
  transform: rotate(20deg) scaleX(-1);
}

/* ===== ESCENA FINAL ===== */
.lux-escena-final {
  position: relative;
  width: 100%;
  display: grid;
  place-items: center;
  margin-top: 50px;  
  overflow: visible;
}

.lux-degradado {
  width: 70%;
  height: 160px;
  background: linear-gradient(
    to top,
    #fdf2f3 0%,
    rgba(253, 242, 243, 0.8) 40%,
    rgba(253, 242, 243, 0) 100%
  );
}

.lux-flores {
  position: absolute;
  bottom: 0;
  left: 90%;
  transform: translateX(-50%) rotate(-44deg);
  width: 100%;
  max-width: 520px;
  pointer-events: none;
  filter: drop-shadow(0 -4px 12px rgba(225, 180, 185, 0.15));
  opacity: 0.95;
}

@media (prefers-reduced-motion: reduce) {
  * {
    transition: none !important;
    animation: none !important;
  }
}
</style>